import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { Monogram } from "./common";
import { useSite } from "../context/SiteContext";

export const NAV = [
  ["Home", "/"], ["About Us", "/about"], ["Projects", "/projects"], ["Krishna Vatika", "/krishna-vatika"],
  ["Why Invest", "/why-invest"], ["Gallery", "/gallery"], ["Contact", "/contact"],
];

export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { openModal } = useSite();
  const { pathname } = useLocation();

  useEffect(() => { setOpen(false); }, [pathname]);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 24);
    fn(); window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  return (
    <header className={`sticky top-0 z-40 border-b transition-[background-color,border-color,box-shadow] duration-300 ${scrolled ? "bg-ivory/90 backdrop-blur-md border-gold/20 shadow-[0_1px_0_rgba(201,169,97,.15)]" : "bg-ivory border-transparent"}`} data-testid="site-header">
      <div className="container-x flex h-[72px] items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="header-logo-link">
          <Monogram />
          <span className="hidden sm:block leading-tight">
            <span className="block font-serif text-lg font-semibold text-emerald-800">M & S Green Estate</span>
            <span className="block text-[10px] uppercase tracking-[0.25em] text-gold-600">Pvt. Ltd.</span>
          </span>
        </Link>
        <nav className="hidden lg:flex items-center gap-8" aria-label="Primary">
          {NAV.map(([label, to]) => (
            <NavLink key={to} to={to} end={to === "/"} className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`} data-testid={`nav-${label.toLowerCase().replace(/\s+/g, "-")}`}>{label}</NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button onClick={() => openModal("enquiry")} className="btn-primary hidden sm:inline-flex !py-2.5 !px-5" data-testid="header-enquire-button">Enquire Now</button>
          <button onClick={() => setOpen(!open)} className="lg:hidden inline-flex h-11 w-11 items-center justify-center text-emerald-800" aria-label="Menu" data-testid="mobile-menu-button">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -8 }} transition={{ duration: 0.25 }} className="lg:hidden border-t border-gold/20 bg-ivory" data-testid="mobile-menu-drawer" aria-label="Mobile">
            <div className="container-x flex flex-col py-4">
              {NAV.map(([label, to], i) => (
                <NavLink key={to} to={to} end={to === "/"} className={({ isActive }) => `py-3.5 font-serif text-xl border-b border-gold/10 ${isActive ? "text-gold-600" : "text-emerald-800"}`} style={{ transitionDelay: `${i * 30}ms` }} data-testid={`mobile-nav-${label.toLowerCase().replace(/\s+/g, "-")}`}>{label}</NavLink>
              ))}
              <button onClick={() => { setOpen(false); openModal("enquiry"); }} className="btn-primary mt-5" data-testid="mobile-enquire-button">Enquire Now</button>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
